<template>
	<v-dialog v-model="visible" :max-width="maxWidth" persistent>
		<v-card color="#FFFFFF" @click.native="close_selection += 1">
			<v-system-bar :color="color" height="12"></v-system-bar>
			<v-alert v-if="error_msg.length !== 0" class="my-1 rounded-b-0" type="error" dense>
				{{ error_msg }}
			</v-alert>
			<div class="pa-4">
				<v-row class="ma-0">
					<span class="title-sytle">{{ commissionId === 0 ? 'Add' : 'Modify'}} 3rd Party Commission</span>
				</v-row>
				<ProgressLinear v-if="loading" class="mx-0 mt-2 mb-4"/>
				<template v-else>
					<v-row class="ma-0">
						<v-col :cols="$vuetify.breakpoint.xsOnly ? 12 : 6" :class="$vuetify.breakpoint.xsOnly ? 'px-0':'pl-0 pr-2'">
							<div class="item-style">Phase</div>
							<v-select
								v-model="phase_select"
								:color="color"
								:menu-props="{ bottom: true, offsetY: true}"
								:loading="phase_loading"
								:items="phase_items"
								item-value="id"
								item-text="desc"
								item-color="media"
								:disabled="commissionId !== 0 || !editable"
								background-color="#FAFAFA"
								outlined
								dense
								hide-details
								return-object
							>
							</v-select>
						</v-col>
						<v-col :cols="$vuetify.breakpoint.xsOnly ? 12 : 6" :class="$vuetify.breakpoint.xsOnly ? 'px-0':'pl-2 pr-0'">
							<div class="item-style">Supplier</div>
							<v-autocomplete
								v-model="supplier_select"
								:items="supplier_items"
								:item-color="color"
								:color="color"
								:autofocus="!supplier_select"
								:menu-props="{ bottom: true, offsetY: true}"
								:loading="supplier_loading"
								:disabled="!editable"
								:error="isSupplierError"
								item-text="desc"
								background-color="#FAFAFA"
								outlined
								dense
								hide-details
								return-object
								clearable
								@change="onSupplierChange($event)"
							>
							</v-autocomplete>
						</v-col>
					</v-row>
					<v-row class="ma-0">
						<v-col :cols="$vuetify.breakpoint.xsOnly ? 12 : 4" :class="$vuetify.breakpoint.xsOnly ? 'px-0':'pl-0 pr-2'">
							<div class="item-style">Currency</div>
							<v-select
								ref="currency"
								v-model="currency_select"
								:items="currency_items"
								:item-color="color"
								:color="color"
								:menu-props="{ bottom: true, offsetY: true}"
								:loading="currency_loading"
								:disabled="!editable"
								:error="isCurrencyError"
								item-text="display_name"
								background-color="#FAFAFA"
								outlined
								dense
								return-object
								:messages="message"
								@change="onCurrencyChange($event)"
							>
								<template v-slot:message="{ message }">
									<span class="item-style px-0 mx-1" style="color: #605AF6">{{ message }}</span>
								</template>
							</v-select>
						</v-col>
						<v-col :cols="$vuetify.breakpoint.xsOnly ? 12 : 4" :class="$vuetify.breakpoint.xsOnly ? 'px-0':'pl-2 pr-0'">
							<div class="item-style">Percentage</div>
							<v-text-field
								class="field-in-perc"
								:value="numberFormat(comm_perc)"
								:color="color"
								:disabled="!editable"
								outlined
								dense
								hide-details
								prefix="%"
								background-color="#FAFAFA"
								@change="onPercentageChange($event)"
							></v-text-field>
						</v-col>
						<v-col :cols="$vuetify.breakpoint.xsOnly ? 12 : 4" :class="$vuetify.breakpoint.xsOnly ? 'px-0':'pl-2 pr-0'">
							<div class="item-style">Amount</div>
							<v-text-field
								class="field-in-perc"
								:value="numberFormat(amount)"
								:color="color"
								outlined
								dense
								hide-details
								background-color="#FAFAFA"
								disabled
							></v-text-field>
						</v-col>
					</v-row>
					<v-row class="ma-0" dense>
						<v-radio-group v-model="apply_radio" :row="!$vuetify.breakpoint.xsOnly" :disabled="!editable" class="mt-0 pt-0" @change="onRadioChange()">
							<template v-slot:label>
								<div class="item-style">Apply to:&nbsp;</div>
							</template>
							<v-radio
								v-for="apply_radio_item in apply_radio_group"
								:key="apply_radio_item.value"
								:value="apply_radio_item.value"
								:color="color"
							>
								<template v-slot:label>
									<div class="item-style">{{ apply_radio_item.label }}</div>
								</template>
							</v-radio>
						</v-radio-group>
					</v-row>
					<div class="table-wrap" style="max-height: 370px">
						<div class="table-wrap-container">
							<v-data-table
								:headers="headers"
								:items="media_list"
								:items-per-page="-1"
								group-by="media_id"
								:group-desc="group_desc"
								show-group-by
								hide-default-footer
								dense
							>
								<template v-slot:group.header="{ group, headers, items, toggle }">
									<td :colspan="headers.length">
										<div @click="toggle()">
											<v-btn icon small>
												<v-icon>$expand</v-icon>
											</v-btn>
											<span class="table-title-style table-title-font-blob table-title-color-nomal">{{ (items[0].phaseDesc)[0] }}&nbsp;</span>
											<span class="table-title-style table-title-font-nomal table-title-color-nomal">for&nbsp;Supplier:</span>
											<span class="table-title-style table-title-font-blob table-title-color-select">{{ (items[0].phaseDesc)[1] }},&nbsp;</span>
											<span class="table-title-style table-title-font-nomal table-title-color-nomal">Kind:&nbsp;</span>
											<span class="table-title-style table-title-font-blob table-title-color-select">{{ (items[0].phaseDesc)[2] }}</span>
										</div>
									</td>
								</template>
								<template v-slot:[`header.startDate`]="{ header }">
									<div style="white-space: nowrap">{{ header.text }}</div>
								</template>
								<template v-slot:[`header.endDate`]="{ header }">
									<div style="white-space: nowrap">{{ header.text }}</div>
								</template>
								<template v-if="apply_radio === appl_bill" v-slot:[`header.bill`]="{ header }">
									<div style="white-space: nowrap">{{ header.text }}</div>
								</template>
								<template v-slot:[`item.startDate`]="{ item }">
									<span style="white-space: nowrap">{{ item.startDate }}</span>
								</template>
								<template v-slot:[`item.endDate`]="{ item }">
									<span style="white-space: nowrap">{{ item.endDate }}</span>
								</template>
								<template v-slot:[`item.gross`]="{ item }">
									<v-row class="ma-0" style="flex-flow: nowrap; align-items: center">
										<span class="table-title-color-select mr-1">{{ item.cost_currency.code }}&nbsp;</span>
										<span class="item-style">{{ numberFormat(item.gross) }}</span>
									</v-row>
								</template>
								<template v-slot:[`item.net`]="{ item }">
									<v-row class="ma-0" style="flex-flow: nowrap; align-items: center">
										<span class="table-title-color-select mr-1">{{ item.cost_currency.code }}&nbsp;</span>
										<span class="item-style">{{ numberFormat(item.net) }}</span>
									</v-row>
								</template>
								<template v-slot:[`item.bill`]="{ item }">
									<v-row class="ma-0" style="flex-flow: nowrap; align-items: center">
										<span class="table-title-color-select mr-1">{{ item.value_currency.code }}&nbsp;</span>
										<span class="item-style">{{ numberFormat(item.bill) }}</span>
									</v-row>
								</template>
								<template v-slot:[`item.commission`]="{ item }">
									<v-row class="ma-0" style="flex-flow: nowrap; align-items: center">
										<v-icon v-if="currency_select === null" small color="rgba(25, 42, 62, 0.5)">mdi-currency-usd</v-icon>
										<span v-if="currency_select !== null" class="table-title-color-select mr-1">{{ currency_select.code }}&nbsp;</span>
										<span class="item-style">{{ numberFormat(item.commission) }}</span>
									</v-row>
								</template>
								<template v-slot:[`item.commissionPercent`]="{ item }">
									<v-text-field
										class="field-in-cell field-in-perc item-style"
										style="max-width: 160px"
										:value="numberFormat(item.commissionPercent)"
										:color="color"
										:disabled="!editable"
										outlined
										dense
										hide-details
										height="24"
										@change="onItemCommissionPercentChange(item.id, $event)"
									>
									</v-text-field>
								</template>
							</v-data-table>
						</div>
					</div>
					<v-row class=" mt-3 mx-0 mb-0" :justify="$vuetify.breakpoint.xsOnly ? 'space-between':'center'">
						<v-btn outlined class="text-capitalize mr-2" color="rgba(25, 42, 62, 0.7)" max-height="36" @click="$emit('close')">Cancel</v-btn>
						<v-btn v-if="commissionId !== 0" class="text-capitalize white--text mr-2" :color="color" :disabled="!isActive" elevation="0" @click="onSave()">Save changes</v-btn>
						<v-btn v-else class="text-capitalize white--text" :color="color" :disabled="!isActive" elevation="0" @click="onSave()">Add 3rd party commission</v-btn>
					</v-row>
				</template>
			</div>
		</v-card>
	</v-dialog>
</template>

<script>
import ProgressLinear from "@/components/progress/progress_getdata_linear.vue";

import Decimal from 'decimal.js';
import moment from 'moment';

const Appl_Gross = 'gross';
const Appl_Net = 'net';
const Appl_Bill = 'bill';

/** 0 - gross, 1 - net, 2 - bill */
const Appl_Gross_Num = 0;
const Appl_Net_Num = 1;
const Appl_Bill_Num = 2;

const Decimal_Places = 6;
const PLAN_TYPE = 'PLAN';

export default {
	name: 'MediaPlanCommissionDialog',
	props: {
		visible: {
			type: Boolean,
			default: false
		},
		maxWidth: {
			type: Number,
			default: 600
		},
		color: {
			type: String,
			default: '#605AF6'
		},
		jobId: {
			type: Number,
			default: 0
		},
		snapId: {
			type: Number,
			default: 0
		},
		commissionId: {
			type: Number,
			default: 0
		},
		mediaPlanningData: {
			type: Array,
			default: () => []
		}
	},
	components: {
		ProgressLinear
	},
	data() {
		this.appl_gross = Appl_Gross;
		this.appl_net = Appl_Net;
		this.appl_bill = Appl_Bill;

		return {
			error_msg: '',
			close_selection: 0,
			loading: false,

			phase_loading: false,
			phase_select: null,
			phase_items: [],
			
			supplier_loading: false,
			supplier_select: null,
			supplier_items: [],

			currency_loading: false,
			currency_select: null,
			currency_items: [],

			comm_perc: '0.00',
			message: '0.0000000',

			apply_radio: Appl_Gross,
			apply_radio_group: [
				{
					label: 'Gross',
					value: Appl_Gross
				},
				{
					label: 'Net',
					value: Appl_Net
				},
				{
					label: 'Bill to client',
					value: Appl_Bill
				},
			],

			headers_init: [
				{
					text: 'Start date',
					sortable: false,
					groupable: false,
					value: 'startDate',
				},
				{
					text: 'End date',
					sortable: false,
					groupable: false,
					value: 'endDate',
				},
				{
					text: 'Units',
					align: 'center',
					sortable: false,
					groupable: false,
					value: 'units',
				},
				{
					text: 'Gross',
					sortable: false,
					groupable: false,
					value: 'gross',
				},
				{
					text: 'Net',
					sortable: false,
					groupable: false,
					value: 'net',
				},
				{
					text: 'Bill to client',
					sortable: false,
					groupable: false,
					value: 'bill',
				},
				{
					text: '3rd party commission ($)',
					sortable: false,
					groupable: false,
					value: 'commission',
				},
				{
					text: '3rd party commission (%)',
					sortable: false,
					groupable: false,
					value: 'commissionPercent',
				}
			],
			media_list: [],

			editable: true,
			order: 0,
			is_deleted: false,
			do_print: true,
			system_currency: null,

			group_desc: []
		}
	},
	async created() {
		this.loading = this.commissionId === 0 ? false : true;

		this.getSystemCurrency(this.jobId);
		await this.getPhaseList();
		await this.getCurrencyList();
		await this.getSupplierList();
		
		if (this.commissionId !== 0) {
			this.getTPC(this.commissionId)
		}
	},
	computed: {
		headers() {
			let headers_tmp = [];

			if (this.headers_init.length !== 0) {
				const removal_head = this.apply_radio_group.filter(apply => { return apply.value !== this.apply_radio });
				const removal_head_value_arr = removal_head.map(header => { return header.value });
				headers_tmp = this.headers_init.filter(header => { return !removal_head_value_arr.includes(header.value) })
			}

			return headers_tmp
		},
		amount() {
			let amount = 0;

			if (this.media_list.length !== 0) {
				this.media_list.forEach(media => {
					amount += Number(media.commission);
				});
			}

			return Number(amount).toFixed(2);
		},
		isSupplierError() {
			let is_supplier_error = false;

			if (!this.supplier_select && (this.currency_select !== null || this.comm_perc !== '0.00')) {
				is_supplier_error = true;
			}

			return is_supplier_error;
		},
		isCurrencyError() {
			let is_currency_error = false;

			if (!this.currency_select && (this.supplier_select !== null || this.comm_perc !== '0.00')) {
				is_currency_error = true;
			}

			return is_currency_error;
		},
		isActive() {
			let is_active = false;

			if (this.phase_select && this.supplier_select && this.currency_select && this.media_list.length !== 0) {
				is_active = true;
			}

			return is_active;
		},
	},
	watch: {
		phase_select() {
			if (this.commissionId === 0) {
				this.setMediaListForCreating(this.phase_select.id);
			}
		}
	},
	methods: {
		getSystemCurrency(job_id) {
			const url = `/api/jobs/${job_id}`;

			axios
				.get(url, {
					headers: {
						"Authorization": "Bearer " + this.$store.state.token,
						"Accept": "application/json"
					}
				})
				.then((val) => {
					const {status, data, reason } = val.data;
					if (status == "OK") {
						this.system_currency = data.currency;

						const today = moment().format('YYYY-MM-DD');
						this.getExchangeRatesForList(data.currency.id, today)
							.then((val) => {
								this.system_currency['rate'] = Number(val.rate);
							})
							.catch((reason) => {
								this.error_msg = reason;
							});
					} else {
						this.error_msg = reason;
					}
				})
				.catch(e => {
					this.error_msg = e.message;
				})
				.finally(() => {
				});
		},
		async getPhaseList() {
			this.phase_loading = true;

			const url = `/api/jobs/${this.jobId}/phases`;

			await axios
				.get(url, {
					headers: {
						"Authorization": "Bearer " + this.$store.state.token,
						"Accept": "application/json"
					}
				})
				.then((val) => {
					const {status, data, reason } = val.data;
					if (status == "OK") {
						this.phase_items = data.map((d, index) => { 
							const obj = {
								id: d.id,
								desc: d.display_name,
								order: index
							};

							return obj;
						});

						if (this.commissionId === 0) {
							this.phase_select = this.phase_items[0];
						}
					} else {
						this.error_msg = reason;
					}
				})
				.catch(e => {
					this.error_msg = e.message;
				})
				.finally(() => {
					this.phase_loading = false;
				});
		},
		async getCurrencyList() {
			this.currency_loading = true;
			
			const url = "/api/expenses/receipts/meta";

			await axios
				.get(url, {
					"Authorization": "Bearer " + this.$store.state.token,
					"Accept": "application/json"				
				})
				.then((val) => {
					const { status, data, reason } = val.data;

					if (status == "OK") {
						this.currency_items = data.currencies;
					} else {
						this.error_msg = reason;
					}
				})
				.catch((e) => {
					this.error_msg = e.message;
				})
				.finally(() => {
					this.currency_loading = false;
				});
		},
		async getSupplierList() {
			this.supplier_loading = true;
			
			let url = `/api/addressbook/supplier`;

			const params = [];
			params.push("include_media=" + true);
			params.push("include_normal=" + false);
			

			if (params.length > 0) {
				url+= "?" + params.join('&');
			}

			await axios
				.get(url, {
					"Authorization": "Bearer " + this.$store.state.token,
					"Accept": "application/json"				
				})
				.then((val) => {
					const { status, data, reason } = val.data;

					if (status == "OK") {
						data.forEach(d => {
							d['desc'] = `${d.code} - ${d.display_name}`
						});
						this.supplier_items = data;
					} else {
						this.error_msg = reason;
					}
				})
				.catch((e) => {
					this.error_msg = e.message;
				})
				.finally(() => {
					this.supplier_loading = false;
				});
		},
		async getTPC(id) {
			this.loading = true;

			const url = `/api/media/media_planning/tpc/${id}`;

			await axios
				.get(url, {
					headers: {
						"Authorization": "Bearer " + this.$store.state.token,
						"Accept": "application/json"
					}
				})
				.then((val) => {
					const {status, data, reason } = val.data;
					if (status == "OK") {
						this.phase_select = data.phase;

						const supplier = data.tpc_supplier;
						const currency = data.tpc_currency ? data.tpc_currency : data.tpc_supplier.supp_currency;
						currency['display_name'] = currency.display_name ? currency.display_name : currency.desc;
						supplier['currency'] = currency;
						supplier['desc'] = `${data.tpc_supplier.adbCode} - ${data.tpc_supplier.adbShort}`
						this.supplier_select = supplier;

						this.currency_select = this.supplier_select.currency;
						const today_date = moment().format('YYYY-MM-DD');
						this.getExchangeRates(this.currency_select.id, today_date)

						this.order = data.order;
						this.is_deleted = data.is_deleted;
						this.do_print = data.do_print;
						this.comm_perc = Number(data.tpc_commperc).toFixed(2);
						this.editable = !data.has_po;

						let apply_radio_tmp = '';
						if (data.tpc_applyto === Appl_Gross_Num) {
							apply_radio_tmp = Appl_Gross;
						}
						if (data.tpc_applyto === Appl_Net_Num) {
							apply_radio_tmp = Appl_Net;
						}
						if (data.tpc_applyto === Appl_Bill_Num) {
							apply_radio_tmp = Appl_Bill;
						}
						this.apply_radio = apply_radio_tmp;

						this.setMediaListForUpdating(data.details);

					} else {
						this.error_msg = reason;
					}
				})
				.catch(e => {
					this.error_msg = e.message;
				})
				.finally(() => {
					this.loading = false;
				});
		},
		async getExchangeRates(currency_id, date) {
			const url = `/api/config/currency/${currency_id}/exchange_rates/${date}`;

			await axios
				.get(url, {
					headers: {
						"Authorization": "Bearer " + this.$store.state.token,
						"Accept": "application/json"
					}
				})
				.then((val) => {
					const {status, data, reason } = val.data;
					if (status == "OK") {
						this.message = Number(data.rate).toFixed(Decimal_Places);
					} else {
						this.error_msg = reason;
					}
				})
				.catch(e => {
					this.error_msg = e.message;
				})
		},
		getExchangeRatesForList(currency_id, date) {
			const url = `/api/config/currency/${currency_id}/exchange_rates/${date}`;

			return new Promise((resolve, reject) => {
				axios
					.get(url, {
						headers: {
							"Authorization": "Bearer " + this.$store.state.token,
							"Accept": "application/json"
						}
					})
					.then((val) => {
						const json = val.data;

						const { status, data, reason } = json;

						if (status == "OK") {
							resolve(data);
						} else {
							reject(reason);
						}
					})
					.catch((e) => {
						reject(e.message);
					});
			});	
		},
		setMediaListForCreating(phase_id) {
			const media_by_phase_filter = this.mediaPlanningData.filter(media => { return media.id === phase_id });

			if (media_by_phase_filter[0].details) {
				const media_by_phase_arr = media_by_phase_filter[0].details.filter(detail => { return detail.record_type === PLAN_TYPE});
				media_by_phase_arr.sort((a,b) => {
					if (a.order === b.order) {
						return a.id - b.id;
					} else {
						return a.order - b.order;
					}
				});
				this.group_desc = [];
				this.group_desc = media_by_phase_arr.map(d => { return d.id});
				this.comm_perc = '0.00';

				const list = [];
				media_by_phase_arr.forEach(media => {
					if (media.record_type === PLAN_TYPE && media.bookings.length !== 0) {
						media.bookings.forEach(booking => {
							const booking_new = JSON.parse(JSON.stringify(booking));

							booking_new['booking_id'] = 0;
							booking_new['tpc_id'] = 0;
							booking_new['startDate'] = moment(booking.booking_start, 'YYYYMMDD').format('DD MMM YYYY');
							booking_new['endDate'] = moment(booking.booking_end, 'YYYYMMDD').format('DD MMM YYYY');
							booking_new['cost_currency'] = media.cost_currency;
							booking_new['currency'] = media.currency;
							booking_new['value_currency'] = media.value_currency;
						
							booking_new['gross'] = Number(booking.amount_fc).toFixed(2);

							let net = 0;
							if (booking_new['cost_currency'].id !== booking_new['value_currency'].id) {
								net = new Decimal(Number(booking.amount_fc)).minus(Number(booking.commamount_fc)).toDecimalPlaces(Decimal_Places).toNumber();
							} else {
								net = Number(booking.net_fc);
							}
							booking_new['net'] = net.toFixed(2);

							booking_new['bill'] = Number(booking.value_fc).toFixed(2);
							booking_new['commission'] = '0.00';
							booking_new['commissionPercent'] = '0.00';
							booking_new['media_id'] = media.id;
							booking_new['phaseDesc'] = [media.description, media.supplier.display_name, media.kind.name];
						
							list.push(booking_new);
						})
					}
				});

				this.media_list = list;
			} else {
				this.media_list = [];
			}
		},
		setMediaListForUpdating(media_list) {
			media_list.sort((a,b) => {
				if (a.order === b.order) {
					return a.id - b.id;
				} else {
					return a.order - b.order;
				}
			});
			this.group_desc = [];
			this.group_desc = media_list.map(d => { return d.id});

			const list = [];

			media_list.forEach(media => {
				if (media.bookings.length !== 0) {
					media.bookings.forEach(booking => {
						const booking_new = JSON.parse(JSON.stringify(booking));

						booking_new['id'] = booking.booking_id;
						booking_new['booking_id'] = booking.tpc_booking_id;
						booking_new['tpc_id'] = booking.tpc_id;
						booking_new['startDate'] = moment(booking.booking_start, ['YYYYMMDD', 'YYYY-MM-DD']).format('DD MMM YYYY');
						booking_new['endDate'] = moment(booking.booking_end, ['YYYYMMDD', 'YYYY-MM-DD']).format('DD MMM YYYY');

						const cost_currency_filter = this.currency_items.filter(c => { return c.id === media.cost_curr_id });
						booking_new['cost_currency'] = cost_currency_filter[0];
						
						booking_new['currency'] = this.system_currency;

						const value_currency_filter = this.currency_items.filter(c => { return c.id === media.value_curr_id });
						booking_new['value_currency'] = value_currency_filter[0];
						
						booking_new['gross'] = Number(booking.booking_gross_fc).toFixed(2);
						booking_new['net'] = Number(booking.booking_net_fc).toFixed(2);
						booking_new['bill'] = Number(booking.booking_billtoclient_fc).toFixed(2);
						booking_new['commission'] = Number(booking.tpc_booking_commamt_fc).toFixed(2);
						booking_new['commissionPercent'] = Number(booking.tpc_booking_commperc).toFixed(2);
						booking_new['media_id'] = media.id;
						booking_new['phaseDesc'] = [media.plan_desc, media.supplier, media.kind];
						
						list.push(booking_new);
					})
				}
			});

			this.media_list = list;
		},
		numberFormat(num_str) {
			let number_format = '';

			if (typeof(num_str) === 'string' && num_str.length !== 0) {
				number_format = new Intl.NumberFormat('en-US', {
					minimumFractionDigits: 2,
					maximumFractionDigits: 2
				}).format(num_str);
			}
			return number_format;
		},
		async onSupplierChange(supplier) {
			if (supplier) {
				const currency_select_arr = this.currency_items.filter(c => { return c.id === supplier.currency.id });
				this.currency_select = currency_select_arr.length !== 0 ? currency_select_arr[0] : null;

				this._checkAutofocusKey();

				if (this.currency_select) {
					const today_date = moment().format('YYYY-MM-DD');
					await this.getExchangeRates(this.currency_select.id, today_date)
				}
			}
		},
		async onCurrencyChange(currency) {
			const today_date = moment().format('YYYY-MM-DD');
			await this.getExchangeRates(currency.id, today_date);

			const comm_perc = this.comm_perc !== '0.00' ? this.comm_perc : null;
			this.onPercentageChange(comm_perc);
		},
		onRadioChange() {
			this.onPercentageChange();
		},
		async onPercentageChange(percentage=null) {
			if (percentage !== null) {
				this.comm_perc = Number(percentage).toFixed(2);
			}

			const current_currency = this.currency_select ? this.currency_select : this.system_currency;
			
			this.media_list.forEach(list => {
				let num_percentage = 0;
				
				if (percentage === null) {
					num_percentage = new Decimal(Number(list.commissionPercent)).div(100);
				} else {
					list['commissionPercent'] = Number(percentage).toFixed(2);
					num_percentage = new Decimal(Number(percentage)).div(100);
				}

				if (this.apply_radio === Appl_Gross) {
					if (current_currency.id !== list.cost_currency.id) {
						const booking_start_date = moment(list.booking_start, 'YYYYMMDD').format('YYYY-MM-DD');
						this.getExchangeRatesForList(list.cost_currency.id, booking_start_date)
							.then((val) => {
								const rate = Number(val.rate);
								const commission_amount = new Decimal(Number(list.gross)).div(rate).times(Number(this.message)).times(num_percentage).toDecimalPlaces(Decimal_Places);
								list['commission'] = commission_amount.toFixed(2);
							})
							.catch((reason) => {
								this.error_msg = reason;
							});
					} else {
						const commission_amount = new Decimal(Number(list.gross)).times(num_percentage).toDecimalPlaces(Decimal_Places);
						list['commission'] = commission_amount.toFixed(2);
					}
				}
				if (this.apply_radio === Appl_Net) {
					if (current_currency.id !== list.cost_currency.id) {
						const booking_start_date = moment(list.booking_start, 'YYYYMMDD').format('YYYY-MM-DD');
						this.getExchangeRatesForList(list.cost_currency.id, booking_start_date)
							.then((val) => {
								const rate = Number(val.rate);
								const commission_amount = new Decimal(Number(list.net)).div(rate).times(Number(this.message)).times(num_percentage).toDecimalPlaces(Decimal_Places);
								list['commission'] = commission_amount.toFixed(2);
							})
							.catch((reason) => {
								this.error_msg = reason;
							});
					} else {
						const commission_amount = new Decimal(Number(list.net)).times(num_percentage).toDecimalPlaces(Decimal_Places);
						list['commission'] = commission_amount.toFixed(2);
					}
				}
				if (this.apply_radio === Appl_Bill) {
					if (current_currency.id !== list.value_currency.id) {
						const booking_start_date = moment(list.booking_start, 'YYYYMMDD').format('YYYY-MM-DD');
						this.getExchangeRatesForList(list.value_currency.id, booking_start_date)
							.then((val) => {
								const rate = Number(val.rate);
								const commission_amount = new Decimal(Number(list.bill)).div(rate).times(Number(this.message)).times(num_percentage).toDecimalPlaces(Decimal_Places);
								list['commission'] = commission_amount.toFixed(2);
							})
							.catch((reason) => {
								this.error_msg = reason;
							});
					} else {
						const commission_amount = new Decimal(Number(list.bill)).times(num_percentage).toDecimalPlaces(Decimal_Places);
						list['commission'] = commission_amount.toFixed(2);
					}
				}				
			});
		},
		onItemCommissionPercentChange(item_id, percentage) {
			const current_currency = this.currency_select ? this.currency_select : this.system_currency;

			this.media_list.forEach(list => {
				if (list.id === item_id) {
					list['commissionPercent'] = Number(percentage).toFixed(2);
					
					let commission_amount = 0;
					const num_percentage = new Decimal(Number(percentage)).div(100);
					
					if (this.apply_radio === Appl_Gross) {
						if (current_currency.id !== list.cost_currency.id) {
							const booking_start_date = moment(list.booking_start, 'YYYYMMDD').format('YYYY-MM-DD');
							this.getExchangeRatesForList(list.cost_currency.id, booking_start_date)
								.then((val) => {
									const rate = Number(val.rate);
									commission_amount = new Decimal(Number(list.gross)).div(rate).times(Number(this.message)).times(num_percentage).toDecimalPlaces(Decimal_Places);
									list['commission'] = commission_amount.toFixed(2);
								})
								.catch((reason) => {
									this.error_msg = reason;
								});
						} else {
							commission_amount = new Decimal(Number(list.gross)).times(num_percentage).toDecimalPlaces(Decimal_Places);
							list['commission'] = commission_amount.toFixed(2);
						}
					}
					if (this.apply_radio === Appl_Net) {
						if (current_currency.id !== list.cost_currency.id) {
							const booking_start_date = moment(list.booking_start, 'YYYYMMDD').format('YYYY-MM-DD');
							this.getExchangeRatesForList(list.cost_currency.id, booking_start_date)
								.then((val) => {
									const rate = Number(val.rate);
									commission_amount = new Decimal(Number(list.net)).div(rate).times(Number(this.message)).times(num_percentage).toDecimalPlaces(Decimal_Places);
									list['commission'] = commission_amount.toFixed(2);
								})
								.catch((reason) => {
									this.error_msg = reason;
								});
						} else {
							commission_amount = new Decimal(Number(list.net)).times(num_percentage).toDecimalPlaces(Decimal_Places);
							list['commission'] = commission_amount.toFixed(2);
						}
					}
					if (this.apply_radio === Appl_Bill) {
						if (current_currency.id !== list.value_currency.id) {
							const booking_start_date = moment(list.booking_start, 'YYYYMMDD').format('YYYY-MM-DD');
							this.getExchangeRatesForList(list.value_currency.id, booking_start_date)
								.then((val) => {
									const rate = Number(val.rate);
									commission_amount = new Decimal(Number(list.bill)).div(rate).times(Number(this.message)).times(num_percentage).toDecimalPlaces(Decimal_Places);
									list['commission'] = commission_amount.toFixed(2);
								})
								.catch((reason) => {
									this.error_msg = reason;
								});
						} else {
							commission_amount = new Decimal(Number(list.bill)).times(num_percentage).toDecimalPlaces(Decimal_Places);
							list['commission'] = commission_amount.toFixed(2);
						}
					}
				}				
			});
		},
		onSave() {
			const params_obj = this._getParams();

			if (this.commissionId === 0) {
				this._onCreateCommission(params_obj);
			} else {
				this._onUpdateCommission(params_obj)
			}
		},
		_getParams() {
			const params_obj = {};

			params_obj['id'] = this.commissionId;
			params_obj['phase_id'] = this.phase_select.id;
			params_obj['supp_id'] = this.supplier_select.id;
			params_obj['comm_perc'] = Number(this.comm_perc);
			params_obj['comm_fc'] = Number(this.amount);
			params_obj['cost_curr_id'] = this.currency_select.id;
			params_obj['is_deleted'] = this.is_deleted;
			params_obj['order'] = this.order;
			params_obj['do_print'] = true;

			let comm_over = 0;
			if (this.apply_radio === Appl_Gross) {
				comm_over = Appl_Gross_Num;
			}
			if (this.apply_radio === Appl_Net) {
				comm_over = Appl_Net_Num;
			}
			if (this.apply_radio === Appl_Bill) {
				comm_over = Appl_Bill_Num;
			}
			params_obj['comm_over'] = comm_over;

			/** _div -> exchange with division rate(from job) */
			let comm_div = 0;
			if (this.system_currency.id !== this.currency_select.id) {
				const comm_div_decimal = new Decimal(this.amount).div(Number(this.message)).times(Number(this.system_currency.rate)).toDecimalPlaces(Decimal_Places);
				comm_div = comm_div_decimal.toNumber();
			} else {
				comm_div = Number(this.amount)
			}
			params_obj['comm_div'] = comm_div;

			if (this.snapId !== 0) {
				params_obj['snap_id'] = this.snapId;
			}

			const tpc_bookings = [];
			this.media_list.forEach(media => {
				const obj = {};
				obj['id'] = this.commissionId === 0 ? 0 : media.id;
				obj['tpc_id'] = media.tpc_id;
				obj['booking_id'] = this.commissionId === 0 ? media.id : media.booking_id;
				obj['comm_perc'] = Number(media.commissionPercent);
				obj['comm_amt_fc'] = Number(media.commission);
				obj['exrate_fc'] = Number(this.message);
				obj['exrate_div'] = Number(this.system_currency.rate);

				if (this.system_currency.id !== this.currency_select.id) {
					const comm_amt_div = new Decimal(media.commission).div(Number(this.message)).times(Number(this.system_currency.rate)).toDecimalPlaces(Decimal_Places);
					obj['comm_amt_div'] = comm_amt_div.toNumber();
				} else {
					obj['comm_amt_div'] = Number(media.commission);
				}

				tpc_bookings.push(obj);
			});
			params_obj['tpc_bookings'] = tpc_bookings;

			return params_obj
		},
		_onCreateCommission(params_obj) {
			const url = '/api/media/media_planning/tpc';

			axios
				.post(url, params_obj, {
					headers: {
						"Authorization": "Bearer " + this.$store.state.token,
						"Accept": "application/json"
					}
				})
				.then((val) => {
					const json = val.data;

					const { status, reason } = json;

					if (status == "OK") {
						this.$emit('close', true)
					} else {
						this.error_msg = reason;
					}
				})
				.catch((e) => {
					this.error_msg = e.message;
				});
		},
		_onUpdateCommission(params_obj) {
			const url = `/api/media/media_planning/tpc/${this.commissionId}`;

			axios
				.put(url, params_obj, {
					headers: {
						"Authorization": "Bearer " + this.$store.state.token,
						"Accept": "application/json"
					}
				})
				.then((val) => {
					const json = val.data;

					const { status, reason } = json;

					if (status == "OK") {
						this.$emit('close', true)
					} else {
						this.error_msg = reason;
					}
				})
				.catch((e) => {
					this.error_msg = e.message;
				});
		},
		_checkAutofocusKey() {
			if (this.supplier_select && !this.currency_select) {
				if (this.$refs.currency) {
					this.$refs.currency.focus();
				}
			}
		}
	}
}
</script>
<style lang="scss" scoped>
.title-sytle {
  font-family: Roboto;
  font-weight: 700;
  font-size: 16px;
  line-height: 24px;
  color: #605AF6;
}
.item-style {
  font-family: Roboto;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  letter-spacing: 0.25px;
  color: #37495F;
}
.table-wrap {
	overflow: auto;
}
.table-wrap-container {
  height: 99%;
}
.table-title-style {
	font-family: Roboto;
  font-size: 14px;
  line-height: 20px;
  letter-spacing: 0.25px;
}
.table-title-font-blob {
	font-weight: 500;
}
.table-title-font-nomal {
	font-weight: 400;
}
.table-title-color-select {
	color: #605AF6;
}
.table-title-color-nomal {
	color: #192A3E;
}

::v-deep {
	.theme--light.v-data-table > .v-data-table__wrapper > table > thead > tr:last-child > th {
    padding-left: 0;
	}
	.v-data-table > .v-data-table__wrapper > table > tbody > tr > td {
    padding-left: 0;
  }
	.v-text-field.v-text-field--enclosed .v-text-field__details {
		padding-left: 0;
		margin-bottom: 0;
	}
	.field-in-cell.v-text-field .v-input__control .v-input__slot {
    min-height: auto !important;
    display: flex !important;
    align-items: center !important;
  }	
	.field-in-perc input {
		padding-right: 4px;
		text-align: end;
	}
}

</style>